import React from "react";
import {
    Grid,
    Typography
} from "@common-ui/ui";

import { ProfileSearch } from "./ProfileSearch";

export const ProfileTitle = (props) => {
    return (
        <Grid item container xs>
            <Grid item xs={6}>
                <Typography variant="h4">{props?.title}</Typography>
            </Grid>
            {!props.hideSearch ?
                <Grid item xs={6}>
                    <ProfileSearch placeholder={props?.searchPlaceHolder} showAddDomain={props.showAddDomain} />
                </Grid>
                : null}
        </Grid>
    );
}

ProfileTitle.defaultProps = {
    title: "Page Title",
    hideSearch: false
};
